import "#js/pages/employeeNotificationForm"
import "#js/pages/companyContactForm"
import "#js/integrations/geocoder"
import "#js/integrations/sentry"
import "#js/components/formsets"
import "#js/components/snackbar"
import "#js/components/formSubmit"
import "#js/components/BookingOption"
import "#js/components/BookingOptionList"
import "#js/components/OfferCard"
import "#js/components/OfferSlider"
import "#js/components/OfferSliderCard"
import "#js/components/CustomDialog"
import "#js/components/cookieConsentModal"
import "#js/components/WaitingRoom"
import "#js/components/FullscreenToggle"
import "#js/components/autocomplete"
import "#js/integrations/algoliaSearch"
import "#js/components/filters"
import "#js/components/offerBookingForm"
import "#js/components/events"
import "#js/components/eventCalendar"
import "#js/components/PersonalizeSlider"
import "#js/components/tracking"
import "#js/integrations/sentry"
import "#js/components/burgerSidebar"
import "#js/components/fileInput"
import * as http from "#js/components/http"
import { UserStorage } from "#js/components/storages"
import { formatBriefing } from "#js/integrations/formatBriefing"

globalThis.userStorage = new UserStorage()
globalThis.formatBriefing = formatBriefing
globalThis.http = http
